import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '@wix/da-ds/pkg/Icons/24x24/Error';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { canPeek } from '../../utils';
import { CommentContext } from '../../CommentContext';
import CommentDataAttrDiv from '../../lego/CommentDataAttrDiv';
import s from './SpamView.scss';
var SpamView = function () {
    var t = useTranslation().t;
    var _a = useContext(CommentContext), setPeeking = _a.setPeeking, comment = _a.comment;
    var isPeekable = canPeek(comment);
    var Tag = isPeekable ? PlainButtonOrLink : 'div';
    return (React.createElement(CommentDataAttrDiv, { className: s['root'] },
        React.createElement(Tag, { className: s['spam'], onClick: isPeekable ? function () { return setPeeking(true); } : undefined },
            React.createElement("span", { className: s['spam-text'] },
                React.createElement(ErrorIcon, { className: s['hidden-icon'] }),
                t('comment.visibility.spam')))));
};
SpamView.displayName = 'SpamView';
export default SpamView;
//# sourceMappingURL=SpamView.js.map